import { axiosInstanceBatchCredit } from "../axios";
import { MapAcquirerUpdate, MapAcquirers, RequestResponse } from "../types";

export const getAcquirer = async (
  pageNumber: number,
  pageSize: number,
  rid: string,
  acquirerCode: string,
  acquirerName: string
): Promise<
  RequestResponse<{
    responseCode: string;
    responseMessage: string;
    records: MapAcquirers[];
    total: number;
  }>
> => {
  try {
    const params: any = {
      page: pageNumber,
      size: pageSize
    };

    if (rid) params.rid = rid;
    if (acquirerCode) params.acquirerCode = acquirerCode;
    if (acquirerName) params.acquirerName = acquirerName;

    const response = await axiosInstanceBatchCredit.get(
      "/api/settlement/acquirer/all",
      {
        params
      }
    );

    return {
      error: false,
      data: {
        records: response.data.data,
        total: response.data.count,
        responseCode: response.data.responseCode,
        responseMessage: response.data.responseMessage
      }
    };
  } catch (err) {
    console.error("Unable to fetch acquirers: ", err);
    const errorResponse = err.response?.data;
    return {
      error: true,
      message:
        errorResponse?.responseMessage ||
        errorResponse?.message ||
        err.message ||
        err,
      data: errorResponse || null
    };
  }
};

export const updateMapAcquirer = async (
  id: number,
  payload: MapAcquirerUpdate
): Promise<RequestResponse> => {
  try {
    const updatedPayload = {
      id,
      ...payload
    };
    await axiosInstanceBatchCredit.put(
      `/api/settlement/acquirer/update`,
      updatedPayload
    );
    return {
      error: false,
      data: null
    };
  } catch (err) {
    console.error("Unable to update acquirer: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const mapAcquirerToRID = async (
  payload: MapAcquirerUpdate
): Promise<RequestResponse> => {
  try {
    await axiosInstanceBatchCredit.post(
      "/api/settlement/acquirer/create",
      payload
    );
    return {
      error: false,
      data: null
    };
  } catch (err) {
    console.error("Unable to map acquirer to RID: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};
